export default __webpack_public_path__ + "static/media/116.9a05133b.jpeg";